import { Map } from "immutable"

import {
    ROLE_LIST_REQUEST as LIST_REQUEST,
    ROLE_LIST_RESPONSE as LIST_RESPONSE,
    ROLE_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    ROLE_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE,
    ROLE_ITEM_SAVE_RESPONSE as ITEM_SAVE_RESPONSE,
    ROLE_ITEM_DELETE_RESPONSE as ITEM_DELETE_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

const defaultSearchCriteria = Map({
    stakeholderID: ""
})

export default buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE,
        ITEM_SAVE_RESPONSE,
        ITEM_DELETE_RESPONSE
    },
    defaultSearchCriteria,
    undefined,
    false
)
